export default __webpack_public_path__ + "images/LeituraNews-Roman1.font.2c3c34420a2f783515df54d2f24a41d1.svg";